/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { Card, Button, Row, Col, message } from 'antd'
import {
  CheckOutlined,
  CloseOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons'
import Compile from '../../../assert/images/compile.svg'
import Modal from './modal'
import './style.css'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      action: '-1', //新增
      type_id: 0,
      record: {},
    }
  }

  componentDidMount() {
    this.props.fetchClubWalletType() //钱包消费区域
  }

  showModal = (item) => {
    this.setState({ visible: true, record: item, action: '1' })
  }
  handleOk = (e) => {
    const { record, action, type_id } = this.state
    let wallet_id = []
    record.classify &&
      record.classify.map((item) => {
        if (item.access == 1) {
          wallet_id.push(item.id)
        }
      })
    if (action === '-1' && sessionStorage.getItem('name')) {
      //新增
      const data = {
        name: sessionStorage.getItem('name'),
        del: sessionStorage.getItem('del') || 0,
        permit: sessionStorage.getItem('permit') || 0,
        commodity: sessionStorage.getItem('commodity') || 0,
        recharge: sessionStorage.getItem('recharge') || 0,
        consumable: sessionStorage.getItem('consumable') || 0,
        self_recharge: sessionStorage.getItem('self_recharge') || 1,
        can_pay_service_charge:
          sessionStorage.getItem('can_pay_service_charge') || 0,
        classify_ids: type_id === 0 ? [] : type_id,
      }
      this.props.fetchAddClubWallet(data)
      this.setState({ visible: false, record: {}, type_id: 0 }, () =>
        this.clearSession()
      )
    } else if (action === '1') {
      //修改
      const data = {
        id: record.id,
        name: sessionStorage.getItem('name') || record.name,
        permit: sessionStorage.getItem('permit') || record.permit,
        commodity: sessionStorage.getItem('commodity') || record.commodity,
        recharge: sessionStorage.getItem('recharge') || record.recharge,
        consumable: sessionStorage.getItem('consumable') || record.consumable,
        del: sessionStorage.getItem('del') || record.del,
        can_pay_service_charge:
          sessionStorage.getItem('can_pay_service_charge') ||
          record.can_pay_service_charge,
        self_recharge:
          sessionStorage.getItem('self_recharge') || record.self_recharge,
        classify_ids: type_id === 0 ? wallet_id : type_id,
      }
      this.props.fetchUpdateClubWallet(data)
      this.setState({ visible: false, record: {}, type_id: 0 }, () =>
        this.clearSession()
      )
    } else {
      message.info('请给钱包取个名字!')
    }
  }
  clearSession = () => {
    sessionStorage.removeItem('name')
    sessionStorage.removeItem('permit')
    sessionStorage.removeItem('commodity')
    sessionStorage.removeItem('recharge')
    sessionStorage.removeItem('consumable')
    sessionStorage.removeItem('del')
    sessionStorage.removeItem('can_pay_service_charge')
  }
  handleCancel = (e) => {
    this.setState({ visible: false, record: {}, type_id: 0 })
  }

  handleEditCheckbox = (value) => {
    this.setState({ type_id: value })
  }

  //选中区域
  checkboxId = (item) => {
    let wallet_id = []
    item &&
      item.map((list) => {
        if (list.access == 1) {
          wallet_id.push(list.id)
        }
      })
    return wallet_id
  }

  render() {
    const { clubWalletList, walletType } = this.props
    const switchItem = [
      { title: '是否禁用', type: 'del' },
      { title: '是否允许直接支付', type: 'permit' },
      { title: '是否可以购买商品', type: 'commodity' },
      { title: '是否可以前台充值', type: 'recharge' },
      { title: '是否可以自助充值', type: 'self_recharge' },
      { title: '是否可以支付服务费', type: 'can_pay_service_charge' },
      { title: '是否可以前台消费', type: 'consumable' },
    ]

    return (
      <div>
        <Button
          type="primary"
          style={{ marginBottom: '20px' }}
          onClick={() => this.setState({ visible: true, action: '-1' })}
        >
          添加钱包
          <PlusCircleOutlined />
        </Button>
        <div className="auth">
          {clubWalletList.list &&
            clubWalletList.list.map((item, idx) => {
              return (
                <Card
                  key={idx}
                  title={item.name}
                  extra={
                    <div>
                      <img
                        src={Compile}
                        className="auth-icon-img"
                        alt="Compile"
                        onClick={() => this.showModal(item)}
                      />
                      {/*<Popconfirm title={`你确认要删除${item.name}吗?`} okText="确认" cancelText="取消" onConfirm={()=>this.props.fetchDelWallet(item.id)}>*/}
                      {/*<img src={Delete} className="auth-icon-img" alt="Delete"/>*/}
                      {/*</Popconfirm>*/}
                    </div>
                  }
                  style={{ width: '32%', margin: '0 1% 1rem 0' }}
                >
                  {switchItem.map((list, idx) => {
                    return (
                      <div key={idx} className="auth-wallet">
                        <div>{list.title}</div>
                        <div>
                          {item[list.type] == '1' ? (
                            <CheckOutlined className="affirm" />
                          ) : (
                            <CloseOutlined className="cancel" />
                          )}
                        </div>
                      </div>
                    )
                  })}
                  <div style={{ marginTop: '1rem' }}>
                    <span>该钱包消费区域:</span>
                    <div className="gutter-example">
                      <Row gutter={16}>
                        {item.classify &&
                          item.classify.map((item, idx) => {
                            if (item.access == 1) {
                              return (
                                <Col className="gutter-row" span={6} key={idx}>
                                  <div className="gutter-box">{item.name}</div>
                                </Col>
                              )
                            }
                          })}
                      </Row>
                    </div>
                  </div>
                </Card>
              )
            })}

          {this.state.visible && (
            <Modal
              {...this.state}
              walletType={walletType}
              handleOk={this.handleOk}
              handleCancel={this.handleCancel}
              handleEditCheckbox={this.handleEditCheckbox}
            />
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubWallet/component/wallet.js